/**
 * Function to get base url with query params
 *
 * @param { string } baseUrl - Base url
 * @param { IPaginationQuery } queryFilters - Filters to send as query
 * @returns { string } - Final url
 */

import { IPaginationQuery } from "Interfaces/PaginatedList";

export const getQueryParams = <T>(
  baseUrl: string,
  queryFilters: IPaginationQuery<T>
): string => {
  const defaultQueryParams: Record<string, string> = {
    pageIndex: String(queryFilters.pageIndex),
    pageSize: String(queryFilters.pageSize),
    filters: JSON.stringify(queryFilters.filters),
  };

  if (queryFilters.sort.length > 0) {
    defaultQueryParams.sortField = String(queryFilters.sort[0].field);
    defaultQueryParams.sortOrder = String(queryFilters.sort[0].sort);
  }

  const queryString = new URLSearchParams(defaultQueryParams).toString();
  return `${baseUrl}?${queryString}`;
};
